import { render, staticRenderFns } from "./tarifasTable.vue?vue&type=template&id=051ab04d"
import script from "./tarifasTable.vue?vue&type=script&lang=js"
export * from "./tarifasTable.vue?vue&type=script&lang=js"
import style0 from "./tarifasTable.vue?vue&type=style&index=0&id=051ab04d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports